import {h, ComponentChildren } from 'preact';

type TableRowProps = {
  children: ComponentChildren;
}

function TableRow({children}: TableRowProps) {
  return (
    <>
      <div className="kits__table-row"> {children} </div>
    </>
  )
}

export {TableRow};
